async function getLastAddedProduct(wrapper,elementToHide){
    const query = `
        query GetLastAddedProducts{
            products(reverse:true,first:10,query:"available_for_sale:true AND created_at:>2020-03-20T15:11:03Z"){
                edges{
                    node{
                        handle
                    }
                }
            }
        }
    `;
    try{
        const response = await executeQuery(query,{});
        if(!response.data) return;
        const products = response.data.products.edges;
        let handlers = products.map(el => el.node.handle);
        
        // Remove entry with same name
        handlers = handlers.filter((product,index,self)=>(            
            index === self.findIndex( handle => (
                handle.toLowerCase() !== product.toLowerCase()
            ))
        ))
        const complete = renderProducts(0,handlers,wrapper)
        if(!complete){
            wrapper.closest('[data-recent-wrapper]').style.display='block';
            wrapper.closest('[data-recently-viewed-wrapper]').classList.remove('is-hidden');
            
            const sliderContainer = wrapper.closest('[data-recently-viewed-wrapper]').querySelector('[data-recent-wrapper]');
            elementToHide.forEach((str,i)=>{
                if(sliderContainer.children[i])
                    sliderContainer.children[i].style.display='none';
            })
            const sectionLabelRecentlyAdd = window.document.getElementById('js_recently-add-heading');
            const sectionLabelRecent = window.document.getElementById('js_recently-view-heading');
            sectionLabelRecentlyAdd.style.display = 'inline';
            sectionLabelRecent.style.display = 'none';
        }
    }
    catch(e){
        console.error(e);
    }
}

//      renderProduct(0,handlers,wrapper,elementToHide);
//      products.forEach((product,i) => {
//          fetch(`/products/${product.node.handle}?section_id=api-product-grid-item`)
//              .then(response => response.text())
//              .then(item => {
//                  const aosDelay = i * 150;
//                  const aosImageDuration = i * 100 + 800;
//                  const aosTextDuration = i * 50 + 800;
//                  const anchorAnimation = wrapper.id ? `#${wrapper.id}` : '';
//                  const fresh = document.createElement('div');
//                  let productReplaced = item.includes('||itemIndex||') ? item.replaceAll('||itemIndex||', i) : item;
//                  productReplaced = productReplaced.includes('||itemAosDelay||') ? productReplaced.replaceAll('||itemAosDelay||', aosDelay) : productReplaced;
//                  productReplaced = productReplaced.includes('||itemAosImageDuration||') ? productReplaced.replaceAll('||itemAosImageDuration||', aosImageDuration) : productReplaced;
//                  productReplaced = productReplaced.includes('||itemAosTextDuration||') ? productReplaced.replaceAll('||itemAosTextDuration||', aosTextDuration) : productReplaced;
//                  productReplaced = productReplaced.includes('||itemAnimationAnchor||') ? productReplaced.replaceAll('||itemAnimationAnchor||', anchorAnimation) : productReplaced;
//                  fresh.innerHTML = productReplaced;
//                  wrapper.innerHTML += fresh.querySelector('[data-api-content]').innerHTML;
                
//                  wrapper.closest('[data-recent-wrapper]').style.display='block';
//                  wrapper.closest('[data-recently-viewed-wrapper]').classList.remove('is-hidden');
                
//                  const sliderContainer = wrapper.closest('[data-recently-viewed-wrapper]').querySelector('[data-slider]');
//                  elementToHide.forEach((str,i)=>{
//                      sliderContainer.children[i].style.display='none';
//                  })
//              })
//              .catch(error=>console.log('error',error))
//      })
// }
//  const renderProduct = (shown,handlers,wrapper,elementsToHide) => {
//      if(handlers.length){
//          fetch(`/products/${handlers[0]}?section_id=api-product-grid-item`)
//              .then(response => response.text())
//              .then(item => {
//                  const aosDelay =shown * 150;
//                  const aosImageDuration =shown * 100 + 800;
//                  const aosTextDuration =shown * 50 + 800;
//                  const anchorAnimation = wrapper.id ? `#${wrapper.id}` : '';
//                  const fresh = document.createElement('div');
//                  let productReplaced = item.includes('||itemIndex||') ? item.replaceAll('||itemIndex||', shown) : item;
//                  productReplaced = productReplaced.includes('||itemAosDelay||') ? productReplaced.replaceAll('||itemAosDelay||', aosDelay) : productReplaced;
//                  productReplaced = productReplaced.includes('||itemAosImageDuration||') ? productReplaced.replaceAll('||itemAosImageDuration||', aosImageDuration) : productReplaced;
//                  productReplaced = productReplaced.includes('||itemAosTextDuration||') ? productReplaced.replaceAll('||itemAosTextDuration||', aosTextDuration) : productReplaced;
//                  productReplaced = productReplaced.includes('||itemAnimationAnchor||') ? productReplaced.replaceAll('||itemAnimationAnchor||', anchorAnimation) : productReplaced;
//                  fresh.innerHTML = productReplaced;

//                  wrapper.innerHTML += fresh.querySelector('[data-api-content]').innerHTML;

//                  handlers.shift();
//                  shown++;
//                  renderProduct(shown,handlers,wrapper,elementsToHide)
//              })
//              .catch(error=>console.log('error',error))
//      }
//      else{
//          wrapper.closest('[data-recent-wrapper]').style.display='block';
//          wrapper.closest('[data-recently-viewed-wrapper]').classList.remove('is-hidden');
        
//          const sliderContainer = wrapper.closest('[data-recently-viewed-wrapper]').querySelector('[data-slider]');
//          elementsToHide.forEach((str,i)=>{
//              sliderContainer.children[i].style.display='none';
//          })
//          const sectionLabelRecentlyAdd = window.document.getElementById('js_recently-add-heading');
//          const sectionLabelRecent = window.document.getElementById('js_recently-view-heading');
//          sectionLabelRecentlyAdd.style.display = 'inline';
//          sectionLabelRecent.style.display = 'none';

//      }